import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from '@phosphor-icons/react';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-ground px-4">
      <div className="w-full max-w-md rounded-goutte border border-rule bg-white p-8 text-center">
        <p className="font-display text-[88px] font-extrabold leading-none tracking-[-0.04em] text-ink" aria-hidden="true">404</p>
        <div className="mx-auto mt-5 flex h-1.5 w-40 overflow-hidden rounded-full" aria-hidden="true">
          {['bg-sante-vivid', 'bg-emprunteur-vivid', 'bg-auto-vivid', 'bg-moto-vivid', 'bg-habitation-vivid', 'bg-animal-vivid', 'bg-prevoyance-vivid'].map((c) => (
            <div key={c} className={`flex-1 ${c}`} />
          ))}
        </div>
        <h1 className="mt-6 font-display text-[28px] font-extrabold tracking-[-0.03em] text-ink">Page introuvable</h1>
        <p className="mt-2 text-ink-muted">
          La page que vous recherchez n'existe pas ou vous n'avez pas l'autorisation d'y accéder.
        </p>
        <Button onClick={() => navigate(-1)} className="mt-6 gap-2 cursor-pointer">
          <ArrowLeft className="h-4 w-4" />
          Retour
        </Button>
        <p className="mt-6 text-sm text-ink-muted">Besoin d'aide ? Contactez le support.</p>
      </div>
    </div>
  );
}
